import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from 'app/api.service';

import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Wattbike Hub';

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics
  ) { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/app.component.ts